import { Leerkracht, LeerkrachtInputModel } from '@models/leerkracht.model';

 
export namespace LeerkrachtenActions {

  export class LoadLeerkrachten {
    static readonly type = '[Leerkrachten] Load Leerkrachten';

    constructor(public forceReload: boolean = false) {
    }
  }

  export class LoadLeerkrachtenSuccess {
    static readonly type = '[Leerkrachten] Load Leerkrachten Success';

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(public payload: any[] | Leerkracht[]) {
    }
  }

  export class LoadLeerkrachtenFailure {
    static readonly type = '[Leerkrachten] Load Leerkrachten Failure';

    constructor(public payload: string) {
    }
  }

  export class FindOneLeerkracht {
    static readonly type = '[Leerkrachten] Find One Leerkracht';

    constructor(public payload: string) {
    }
  }

  export class SelectLeerkracht {
    static readonly type = '[Leerkrachten] Select Leerkracht';

    constructor(public payload: string) {
    }
  }

  export class DeselectLeerkracht {
    static readonly type = '[Leerkrachten] Deselect Leerkracht';
  }

  export class CreateLeerkracht {
    static readonly type = '[Leerkrachten] Create Leerkracht';

    constructor(public leerkrachtInput: LeerkrachtInputModel) {
    }
  }

  export class CreateLeerkrachtSuccess {
    static readonly type = '[Leerkrachten] Create Leerkracht Success';

    constructor(public leerkracht: Leerkracht) {
    }
  }

  export class CreateLeerkrachtFailure {
    static readonly type = '[Leerkrachten] Create Leerkracht Failure';

    constructor(public payload: string) {
    }
  }

  export class UpdateLeerkracht {
    static readonly type = '[Leerkrachten] Update Leerkracht';

    constructor(public persoonId: string, public leerkrachtInput: LeerkrachtInputModel) {
    }
  }

  export class DeleteLeerkracht {
    static readonly type = '[Leerkrachten] Delete Leerkracht';

    // constructor(public onderwijsLocatieId: string, public leerkracht: Leerkracht) {
    constructor(public leerkracht: Leerkracht) {
    }
  }

  export class DeleteLeerkrachtSuccess {
    static readonly type = '[Leerkrachten] Delete Leerkracht Success';
  }

  export class DeleteLeerkrachtFailure {
    static readonly type = '[Leerkrachten] Delete Leerkracht Failure';

    constructor(public payload: string) {
    }
  }

}
